module.exports = __webpack_public_path__ + "img/四川天府新区新兴中学附属小学.4d641b59.jpg";